<template>
    <BModal :model-value="modal" scrollable centered title="Technician" hide-footer @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Technician</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <div class="form-group">
                <BFormInput type="text" v-model="technicianForm.name" placeholder="Name"></BFormInput>
            </div>
            <div class="form-group">
                <BFormInput type="text" v-model="technicianForm.type" placeholder="Type"></BFormInput>
            </div>
        </BForm>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2">{{ technicianData && technicianData.uuid ? 'Update' : 'Save'}}</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template> 
    </BModal>
</template>

<script>
import { BModal, BFormInput,BButton, BForm } from 'bootstrap-vue-next';
import { ref, inject, watch } from 'vue';

export default {
    components: {
        BModal,
        BFormInput,
        BButton,
        BForm
    },
    props: {
        modal: Boolean,
        technicianData: Object,
    },
    emits: ["update:modal"],
    setup(props, { emit }) {
        const repositories = inject('repositories');
        const technicianRepository = repositories ? repositories.technician : null;

        const technicianForm = ref({
            name: '',
            type: ''
        });

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        }

        const handleAction =  () => {
            props.technicianData.uuid ? update() : create()
        }

        const create = async () => {
            await technicianRepository.create(technicianForm.value).then(() => {
                updateModal(false)
                technicianForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        const update = async () => {
            await technicianRepository.update(technicianForm.value, props.technicianData.uuid).then(() => {
                updateModal(false)
                technicianForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        watch(() => props.technicianData, (newData) => {
            if (newData) {
                technicianForm.value = { ...newData };
            }
        }, { immediate: true });

        return {
            technicianForm,
            updateModal,
            handleAction,
            create,
            update
        }
    }
}
</script>


